import React, { Component } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import { Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported
import PhotoGalleryImageEditor from "./photoGallery/PhotoGalleryImageEditor";
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class SlovinaPriceTable extends Component {
  webcamRef = React.createRef(null);
  Partimages = React.createRef(null);
  state = {
    data: [],
    Dents: [],
    words: {},
    lang: "si",
    swissTableSL: [],
    selected: {
      Hood: false,
      LeftFrontFender: false,
      LeftFrontDoor: false,
      LeftBackDoor: false,
      LeftBackFender: false,
      Trunk: false,
      TrunkCover: false,
      RightBackFender: false,
      RightBackDoor: false,
      RightFrontDoor: false,
      RightFrontFender: false,
      Roof: false,
      LeftRoofFrame: false,
      RightRoofFrame: false,
    },

    ALUPercentage: "",
    LAKPercentage: "",
    isLightBoxOpen: false,
    loading: false,
    imageSrc: "",
    captureImageName: "",
    part_images: [],
    imagesModalCurrentSourceIndex: 0,
    isEditor: false,
    isEditLoading: false,
    isDeleteLoading: false,
    isRotateLoading: false,
    loading: false,
    extrapart: {},
    imageArr: [],
    imageArrDamage: [],
    currentImageIndex: 0,
    filteredImages: [],
    insuaranceProvider: {}
  };
  count = [];
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };

  getJsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        if (r.data.Client != "") {
          this.getInsurenceClients()
        }
        const arrDataAE = [
          //1
          [
            "Dämmung",
            "Gitter",
            "Komplett"
          ],
          //2
          [
            "Scheinwerfer",
            "Radhaus",
            "Komplett"
          ],
          //3
          [
            "Komplett",
            "Schachtleiste",
            "Verkleidung",
            "Spiegel",
            "Griff"
          ],
          //4
          [
            "Komplett",
            "Schachtleiste",
            "Verkleidung",
            "Griff"
          ],
          //5
          [
            "Rücklicht",
            "Verkleidung",
            "Radhausschale",
            "TankEinsatz",
          ],
          //6
          [
            "3. Bremsleucht",
            "Heckklappe",
            "Verkleidung"
          ],
          //7
          [
            "3. Bremsleucht",
            "Heckklappe",
            "Verkleidung"
          ],
          //8
          [
            "Rücklicht",
            "Verkleidung",
            // "Radhausschale", 
            "Radhausschale (RBF)",
            "TankEinsatz"
          ],
          //9
          [
            "Komplett",
            "Schachtleiste",
            "Verkleidung",
            "Griff"
          ],
          //10
          [
            // "Schachtleiste",
            // "Verkleidung",
            // "Spiegel",
            // "Komplett",
            // "Griff"
            "Komplett",
            "Schachtleiste",
            "Verkleidung",
            "Spiegel",
            "Griff"
          ],
          //11
          [
            "Schachtleiste",
            "Radhaus",
            "Komplett"
          ],
          //12
          [
            "Dämmung",
            "Himmel",
            "Panorama",
            "Dachantenne"
          ],
          //13
          [
            "Dachreling"
          ],
          //14
          [
            "Dachreling"
          ],
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Frontscheibe", "Rahmen", "StoBstange"],

        ];
        // this.setState({ data: r.data, Dents: r.data.Dents });
        r.data.Dents && r.data.Dents.length > 0 && r.data.Dents.map((dent, index) => {
          dent.arrAE = arrDataAE[index];
        });

        const arrDataErsetzenErsetzen = [
          //1
          [
            "Befestigungssatz",
            "Embleme",
            "Motorhaube"
          ],
          //2
          [
            "Befestigungssatz",
            "Blinker",
            "Kotflügel "
          ],
          //3
          [
            "Tür",
            "Zierleiste:",
            "Befestigungssatz",
            "Spiegel",
            "Schachtleiste",
            "Blende:",
            "Türfolie",
          ],
          //4
          [
            "Tür",
            "Zierleiste:",
            "Befestigungssatz",
            "Schachtleiste",
            "Blende:",
            "Türfolie",
          ],
          //5
          [
            "Rückleuchte",
            "Seitenscheibe:",
            "Zierleiste Scheibe",
          ],
          //6
          [
            "3. Bremsleucht",
            "Heckklappe",
            "Leuchte IL ",
            "Leuchte IR",
            "Befestigungssatz",
            "Embleme",
          ],
          //7
          [
            "3. Bremsleucht",
            "Heckklappe",
            "Leuchte IL ",
            "Leuchte IR",
            "Befestigungssatz",
            "Embleme",
          ],
          //8
          [
            "Rückleuchte",
            "Seitenscheibe:",
            // "Zierleiste Scheibe"
            "Zierleiste Scheibe (RBF)"
          ],
          //9
          [
            "Tür",
            "Zierleiste:",
            "Befestigungssatz",
            "Schachtleiste",
            "Blende:",
            "Türfolie",
          ],
          //10
          [
            // "Tür", 
            // "Türfolie",
            // "Spiegel",
            // "Zierleiste:",
            // "Schachtleiste",
            // "Befestigungssatz",
            // "Blende:"
            "Tür",
            "Zierleiste:",
            "Befestigungssatz",
            "Spiegel",
            "Schachtleiste",
            "Blende:",
            "Türfolie"
          ],
          //11
          [
            "Befestigungssatz",
            "Blinker",
            "Kotflügel"
          ],
          //12
          [
            "Himmel",
            "Dämmung x 0",
            "Dachantenne",
            "Handgriff x 0"
          ],
          //13
          [
            "Kap. Reling x 0",
            "Dachleiste"
          ],
          //14
          [
            "Kap. Reling x 0",
            "Dachleiste"
          ],
          // [
          //   "Heckscheibe",
          //   "Wischerkappe",
          //   "Tankdeckel",
          //   "Spolier",
          //   "StoBstange",
          // ],
        ];
        r.data.Dents && r.data.Dents.map((dent, index) => {
          dent.arrErsetzen = arrDataErsetzenErsetzen[index];
        });

        this.getFallbackDetails();

        // this.setState({
        //   data : this.state.data
        // })
        this.setState({ data: r.data, Dents: r.data.Dents, Client: r.data.Client });
      }
    });
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      const response = await axios.post(url)
      if (response.data) {
        response.data.map((info) => {
          if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() && this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
            this.setState({ insuaranceProvider: info })
          }
        })
      }
    }
  };

  componentDidMount() {
    this.getLang();
    this.getJsonApi();
    // this.getFallbackDetails();
    this.extrapartimages();
    this.getScanImages()
  }

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images ? images.filter(image => image.includes(keyword)) : [];
        };

        const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
        ];

        const right = [
          ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(data.RightBackFender || data.right, "RightBackFender")
        ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,


          ],
        });

        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage, "LeftBackFender")
        ];

        const rightDamage = [
          ...filterImages(data.RightFrontFender_damage, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage, "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage, "RightBackFender")
        ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,


          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };

  getFallbackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);

    function hexToRgb(hex) {
      if (!hex) {
        return null; // Return null if hex color is null or undefined
      }

      hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }

    let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
    let rgbaColor;

    if (rgbColor !== null) {
      rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;
    } else {
      // Handle case when rgbColor is null
      rgbaColor = 'rgba(0, 0, 0, 0.20)'; // Default color
    }

    if (res.data.success !== false) {
      this.props.getSelectedPartnerId({
        duplicateSelectedPartnerId: res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
        isDuplicateVin: res.data.is_vin_duplicate
      })
      this.setState({
        ALUPercentage: res.data.alu,
        LAKPercentage: res.data.lak,
        PrimaryColor: res.data.primary_color || "#FF0000",
        SecondaryColor: res.data.secondary_color || "#000000",
        PrimaryTextColor: res.data.primary_text_color || "#000000",
        SecondaryTextColor: res.data.secondary_text_color || "#fff",
        rgbaColor: rgbaColor,

      });
    }
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  saveChanges = (payload) => {
    const { data } = this.state;
    payload.Dents.map((part) => {
      if (part.Plastic) {
        part.A = 0;
        part.B = 0;
        part.C = 0;
        part.TotalDents = 0;
        part.Alu = false;
        part.Push2paint = false;
      }
    });
    payload = payload
    const totalDents = this.getTotalDents();
    payload["TotalDentCount"] = totalDents;
    payload.IsPriceTableUpdated = true;

    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem("selectedFile")}&dents=${totalDents}&TabViewUpdated=${!data.TabViewUpdated}`;

    Axios.post(url, payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "Data saved successfully",
      });
      this.getScanImages()
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };
  // change = (part, e, index, key) => {
  //   const { Dents, data } = this.state;
  //   const totalDents = Dents[index].TotalDents;
  //   Dents[index][key] = e.target.checked;
  //   this.setState({ data });
  //   this.saveChanges(data, totalDents);
  // };

  change = (part, e, index, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;

    if (key === "Replace") {
      if (Dents[index][key]) {
        Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
      } else {
        Dents[index]["Alu"] = false;
        Dents[index]["Push2paint"] = false;
        Dents[index]["AW"] = 0;
      }
    } else {
      if (Dents[index]["Replace"]) {
        Dents[index]["Replace"] = false;
        Dents[index]["Ersetzen"] = []
        Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
      }
      if (!Dents[index][key]) {
        if (key === "Alu" && this.state.ALUPercentage) {
          Dents[index]["AW"] = Math.ceil(
            parseFloat(Dents[index]["AW"]) +
            (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
            100.0
          );
        } else if (key === "Push2paint" && this.state.LAKPercentage) {
          Dents[index]["AW"] = Math.ceil(
            parseFloat(Dents[index]["AW"]) +
            (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
            100.0
          );
        }
      } else {
        if (key === "Alu" && this.state.ALUPercentage) {
          Dents[index]["AW"] = Math.floor(
            parseFloat(Dents[index]["AW"]) -
            (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
            100.0
          );
        } else if (key === "Push2paint" && this.state.LAKPercentage) {
          Dents[index]["AW"] = Math.floor(
            parseFloat(Dents[index]["AW"]) -
            (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
            100.0
          );
        }
      }
    }
    Dents[index][key] = e.target.checked;

    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };
  changeAE = (event, index, value, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;
    const aeArr = Array.isArray(Dents[index]["AE"]) ? Dents[index]["AE"] : [];

    if (event.target.checked) {
      // if (key === "AE") {
      aeArr.push(`${value}`);
      // Dents[index]["AE"] = [];
      // }
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }

    Dents[index]["AE"] = aeArr;
    // Dents[index]["AE"] = [];
    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };

  changeErsetzen = (event, index, value, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;
    const ersetzenArr = Array.isArray(Dents[index]["Ersetzen"])
      ? Dents[index]["Ersetzen"]
      : [];

    if (event.target.checked) {
      // if (key === "Ersetzen") {
      ersetzenArr.push(`${value}`);
      // Dents[index]["Ersetzen"] = [];
      // }
    } else {
      ersetzenArr.map((val, indx) => {
        if (value == val) {
          ersetzenArr.splice(indx, 1);
        }
      });
    }

    Dents[index]["Ersetzen"] = ersetzenArr;
    if (ersetzenArr.length && (Dents[index].Replace === false || Dents[index].Replace === '')) {
      this.change("", event, index, "Replace")
    }
    else if (ersetzenArr.length === 0 && Dents[index].Replace === true) {
      this.change("", event, index, "Replace")
    }
    // Dents[index]["Ersetzen"] = [];
    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };
  handleChange = (e) => {
    const { data } = this.state
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    })
  }
  hadnleDentsChanges = (part, e, index) => {
    const { Dents } = this.state
    const name = e.target.name;
    const value = e.target.value;
    Dents[index][name] = value ? parseFloat(value) : 0;
    Dents[index]['TotalDents'] = Dents[index]['A'] + Dents[index]['B'] + Dents[index]['C']
    this.setState({
      Dents
    })
  }
  getTotalDents = () => {
    const { Dents } = this.state;
    let totalDents = Dents &&
      Dents.reduce(
        (acc, num) =>
          parseInt(acc) + parseInt(num.TotalDents),
        0
      )
    return totalDents
  }

  handlePartimages_extra = (e, part, index) => {
    const { isLightBoxOpen } = this.state
    this.setState({
      imageSrc: "",
      captureImageName: part,
      imageName: part,
    });
    this.imageExistOrNot_extra(part, true)
      ? this.setState({
        isLightBoxOpen: !isLightBoxOpen,
        imageName: part,
      }
        , () =>
          this.getIndex()
      )
      :
      this.refs.Partimages.click();
  }
  getIndex = async () => {
    const { part_images, imageName, extrapart } = this.state;
    let img = extrapart[imageName]
    this.setState({
      isLightBoxOpen: true,
    })
  }

  getBase644 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };

  capture = async (e) => {
    const { files } = e.target;
    const base64 = await this.getBase644(files[0]);
    this.setState({
      imageSrc: base64,
    },
      () => {
        this.uploadImage();
      }
    );
  };

  uploadImage = () => {
    this.setState({
      loading: true,
    })
    const { imageSrc, captureImageName } = this.state;
    const { vin } = this.props;
    let captureDate = moment().utc(true).format(`DD-MM-YYYY hh:mm`);
    // const url = configuration.uploadExtraImages;
    const url = configuration.uploadExtraPartImage;
    // const formData = new FormData();
    // formData.append("img", imageSrc);
    // formData.append("vin", vin || localStorage.getItem("selectedFile"));
    // formData.append("partnerId", localStorage.getItem("partnerId"));
    // formData.append("captureDate", captureDate);
    // formData.append(
    //   "partName",
    //   captureImageName.includes("/")
    //     ? captureImageName.split("/")[1]
    //     : captureImageName
    // );
    let payload = {
      img: imageSrc,
      vin: vin || localStorage.getItem("selectedFile"),
      partnerId: localStorage.getItem("partnerId"),
      partName: captureImageName.includes("/")
        ? captureImageName.split("/")[1]
        : captureImageName,
      captureDate: captureDate
    };
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status === 200) {
          this.extrapartimages();
          Toast.fire({
            type: "success",
            title: "Image upload successfully!",
          });
          this.setState({
            isLightBoxOpen: false,
            loading: false
          });
        } else if (res.data.status === 500) {
          Toast.fire({
            type: "error",
            title: "Internal server error!",
          });
          this.setState({
            loading: false
          })
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
          this.setState({
            loading: false
          })
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
        this.setState({
          loading: false
        })
      })
      .finally(() => {
        this.setState({
          imageSrc: "",
          isLightBoxOpen: false,
        })
        this.refs.Partimages.value = ""
      });
  };

  imageExistOrNot_extra = (part, boolean) => {
    const { part_images, extrapart, imageName } = this.state;
    if (extrapart) {
      let img = extrapart[part]
      if (boolean) {
        return img && img.length > 0 ? true : false;
      } else {
        return img && img.length > 0 ? "red" : "black"
      }
    } else {
      if (boolean) {
        return false;
      } else {
        return "black"
      }
    }

  };

  extrapartimages = () => {
    const { imageName, captureImageName } = this.state;
    const url = configuration.getExtraPartImage;
    let payload = {
      partnerId: localStorage.getItem("partnerId"),
      vin: localStorage.getItem("selectedFile"),
    };
    Axios.post(url, payload)
      .then((res) => {
        if (res.status == 200) {
          this.setState({
            extrapart: res.data.data
          })
        }
      });
  }

  handleDelete = () => {
    this.setState({
      isDeleteLoading: true,
    });
    const { imageName } = this.state;
    const url = configuration.deleteExtraPartImage;
    const { vin } = this.props;
    // let img = this.state.part_images.filter((item) => item.split("_")[1] === imageName)
    let img = this.state.extrapart[imageName][this.state.extrapart[imageName].length - 1]
    const data = new FormData();
    data.append("imageName", img)
    data.append("partName", imageName);
    data.append("vin", vin || localStorage.getItem("selectedFile"));
    data.append("partnerId", localStorage.getItem("partnerId"));
    axios
      .post(url, data)
      .then((res) => {
        this.setState(
          {
            isDeleteLoading: false,
            isLightBoxOpen: false,
          },
          () => {
            if (res.data.status === 200) {
              this.extrapartimages();
              Toast.fire({
                type: "success",
                title: "Image deleted successfully!",
              });
            } else {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            }
          }
        );
      })
      .catch((err) => {
        this.setState({
          isDeleteLoading: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      });
  };
  toggleEdit = async () => {
    this.setState({
      isEditLoading: true,
    });
    this.getBase64()
  };
  getBase64 = async (isDownload) => {
    const { isEditor, isLightBoxOpen, imageName } = this.state;
    const partner_id = localStorage.getItem("partnerId");
    const { vin } = this.props;
    let img = this.state.extrapart[imageName][0]
    await axios
      // .get(configuration.extraImageToBase64, {
      .get(configuration.extraPartImageToBase64, {
        params: {
          partner_id,
          vin_number: vin ? vin : localStorage.getItem("selectedFile"),
          img_name: imageName,
          img_full_name: img,
        },
      })
      .then((response) => {
        if (response !== undefined) {
          this.setState({
            ...this.state,
            data64Url: response.data.base64_img,
            imageUrl: imageName,
            isEditLoading: false,
          });
        }
      })
      .catch((err) => {
      })
      .finally(() => {
        this.setState({
          isEditor: isDownload ? false : !isEditor,
          isLightBoxOpen: !isLightBoxOpen,
          isEditLoading: false,
        });
      });
  }

  upload = () => {
    this.setLoader(true);
    const { imageName, part_images } = this.state;
    let img = this.state.extrapart[imageName][this.state.extrapart[imageName].length - 1]
    var ext = img && img.split(".")[1]
    const { vin } = this.props;
    let partnerId = localStorage.getItem("partnerId");
    var imageEditorCanvas = document.getElementsByClassName("lower-canvas");
    var base64image = imageEditorCanvas[0].toDataURL("image/" + ext, 1.0);
    let url = configuration.editExtraPartImage;
    let utcHours = moment().toString().split("GMT")[1].slice(0, 3) + ':' + moment().toString().split("GMT")[1].slice(3, 5);
    let captureDate = moment().utc(false).format(`DD-MM-YYYY hh:mm ${utcHours} UTC`);
    let payload = {
      // img: base64image.replace("jpeg", "jpg"),
      img: base64image,
      vin: vin || localStorage.getItem("selectedFile"),
      partnerId,
      partName: imageName,
      imageName: img
    };
    axios
      .post(url, payload)
      .then((res) => {
        this.setLoader(false);
        this.setState({
          isEditor: false,
        });
        if (res.data.status === 200) {
          this.extrapartimages();
          Toast.fire({
            type: "success",
            title: "Image upload successfully!",
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        this.setLoader(false);
        this.setState({
          isEditor: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      })
  };

  setLoader = (loader) => {
    if (loader) {
      document.getElementsByClassName(
        "upload_image_photo_app_gallery"
      )[0].innerHTML = "Uploading...";
    } else {
      document.getElementsByClassName(
        "upload_image_photo_app_gallery"
      )[0].innerHTML = "Ok";
    }
  };
  handleRetake = () => {
    this.refs.Partimages.click();
  };

  handlerotate = () => {
    this.setState({
      isRotateLoading: true,
    });
    const { imageName, part_images } = this.state;
    const { vin, viewType } = this.props;
    let img = this.state.extrapart[imageName][this.state.extrapart[imageName].length - 1]
    // var images_name = part_images.filter(item => item && item.split("_")[1] == imageName)
    // var images_name_1 = images_name[images_name.length - 1];
    let url = configuration.rotateExtraPartImage;
    const formData = new FormData();
    formData.append("img", img);
    formData.append("vin", vin || localStorage.getItem("selectedFile"));
    formData.append("partnerId", localStorage.getItem("partnerId"));
    formData.append("partName", imageName);
    axios
      .post(url, formData)
      .then((res) => {
        this.setState(
          {
            isRotateLoading: false
          },
          () => {
            if (res.data.status === 200) {
              this.extrapartimages();
              this.setState({
                loading: false,
              });
            } else {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
              this.setState({
                loading: false
              });
            }
          }
        );
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
        this.setState({
          loading: false,
        })
      })
      .finally(() => {
        this.setState({
          loading: false,
        })
        this.refs.Partimages.value = ""
      });
  }
  plasticChange = (part, e, index, key) => {
    const { name } = e.target;
    const { Dents, data } = this.state;
    // if (e.target.checked) {
    //   data["Dents"][index]["AvgDiaMm"] = 0
    //   data["Dents"][index]["TotalDents"] = 0
    // } else{
    //   data["Dents"][index]["AvgDiaMm"] = data["Dents"][index]["B"]
    //   data["Dents"][index]["TotalDents"] = data["Dents"][index]["A"]
    // }
    data["Dents"][index][key] = e.target.checked;
    this.setState({ data }, () => {
      // this.saveChanges(data)
    });
  };

  // toggle = (partName, showImg, isPlastic) => {
  //   if (showImg) {
  //     const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
  //       const spiltUrl = image.split("/")[6];
  //       const part = isPlastic
  //         ? spiltUrl && spiltUrl.split("_")[0]
  //         : spiltUrl && spiltUrl.split("_")[1];
  //       return part === partName;
  //     });
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //       currentImageIndex: 0,
  //       filteredImages: imageArr, 
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };
  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
        const reportInclude = spiltUrl && spiltUrl.includes("Report")
        const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
        return part === partName;
      });
      console.log(imageArr);
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };


  // toggle = (partName, showImg, isPlastic) => {
  //   if (showImg) {
  //     const imageArr = this.state.imageArr && this.state.imageArr && this.state.imageArr.filter((image) => {
  //       const spiltUrl = image.split("/")[6];
  //       const part = isPlastic
  //         ? spiltUrl && spiltUrl.split("_")[0]
  //         : spiltUrl && spiltUrl.split("_")[1];
  //       return part === partName;
  //     });
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //       currentImageIndex: 0,
  //       filteredImages: imageArr, 
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };

  render() {
    const dynamic_Table_Colors = {
      '--table-even-color': this.state.rgbaColor || '#E8F3FF',
      '--table-header-color': this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || '#D80707',
      '--table-footer-color': this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || '#000',
      '--table-header-text-color': this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || '#000',
      '--table-footer-text-color': this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || '#fff',
    };
    const { Dents, data, captureImageName, imageSrc, part_images, isLightBoxOpen, isEditLoading, isDeleteLoading, loading, isEditor, isRotateLoading, modal } = this.state;
    const [partnerId, vin] = [localStorage.getItem('partnerId'), localStorage.getItem('selectedFile')]
    let toolbarButtons;
    toolbarButtons = [
      <>
        <div className="photo_app_image_lightbox_wrapper">
          <button
            onClick={() => this.setState({ isLightBoxOpen: !isLightBoxOpen })}
          >
            <i className="fa fa-check"></i>
          </button>
          <button onClick={() => this.handleRetake()}>
            <i className="fa fa-camera"></i>
          </button>
          <button onClick={() => this.toggleEdit()}>
            {isEditLoading ? <Spinner /> : <i className="fa fa-pencil"></i>}
          </button>
          <button onClick={() => this.handlerotate()}>
            {isRotateLoading ? <Spinner /> : <i className="fa fa-repeat"></i>}
            {/* <i className="fa fa-repeat"></i> */}
          </button>
          <button onClick={() => this.handleDelete()}>
            {isDeleteLoading ? <Spinner /> : <i className="fa fa-trash"></i>}
          </button>
        </div>
      </>,
    ];
    const { Authorized } = this.state.data
    return (
      <>
        <div className={`all-price-table-wrapper slovenia_price_table_wrapper  ${this.props.viewType === "TabView" ? 'container-fluid ' : 'container'} `}>
          <div className="row slovenia_price_table_row">
            <div className="col-12 p-0">
              <div className="row p-0">
                <div className="col-lg-4 col-md-4 col-sm-4 col-6 p-0">
                  <h3 className="report-title">{this.lang("Damage Description")}</h3>
                </div>
                {this.props.is_extra_columns_visible &&
                  <div className="col-lg-8 col-md-8 col-sm-8 col-6 p-0 slovania-button-col">
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        style={{
                          // padding:'5px',
                          backgroundColor: '#F20000',
                          padding: "5px 10px",
                          color: 'white',
                          border: "none",
                          borderRadius: "5px",
                          fontSize: "16px",
                        }}
                        onClick={() => this.saveChanges(data)}>{this.lang('Update Table')}
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          {!this.props.is_extra_columns_visible_mini_fullreport &&
            <div className={`row slovenia_price_table_row  ${this.props.viewType === "TabView" ? "arrow_table_main_wrapper" : ""}`}>
              <div className="col-lg-12 p-0">
                <div className="table-responsive">
                  <table
                    width="100%"
                    className="table w-100 table_sl_one">
                    <thead>
                      <tr width="100%">
                        <th
                          rowSpan={2}
                          width={"16%"}
                          style={dynamic_Table_Colors}
                          className={`part-tr both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border" : ""}`}
                        >
                          {this.lang("Damage Description")}
                        </th>
                        <th className="empty_row"></th>

                        {
                          partnerId == "demo-sl" &&
                          <>
                            <th
                              width={"7%"}
                              style={dynamic_Table_Colors}
                              className={`replace-tr row-ae both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border dark-gray-col" : ""}`}
                            >
                              {this.lang("plastic")}
                            </th>
                            <th className="empty_row"></th>
                          </>
                        }
                        <th
                          width={"8%"}
                          style={dynamic_Table_Colors}
                          className={`part-tr min-width-100 top-left-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border light-gray-col" : ""}`}
                        >
                          {this.lang("A")}
                        </th>
                        <th
                          width={"8%"}
                          style={dynamic_Table_Colors}
                          className={`part-tr min-width-100 text-left ${this.props.viewType === "TabView" ? "thead_bottom_border light-gray-col" : ""}`}
                        >
                          {this.lang("B")}
                        </th>
                        <th
                          width={"8%"}
                          style={dynamic_Table_Colors}
                          className={`part-tr min-width-100 top-right-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border light-gray-col" : ""}`}
                        >{this.lang("C")}
                        </th>
                        <th className="empty_row"></th>

                        <th
                          width={"10%"}
                          style={dynamic_Table_Colors}
                          className={`dents-tr both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border" : ""}`}
                        >
                          {this.lang("Total Dents")}
                        </th>

                        <th className="empty_row"></th>
                        {/* <th className="aw-tr" width="5%">Aw</th> */}
                        <th
                          width={"5%"}
                          style={dynamic_Table_Colors}
                          className={`alu-tr both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border orange-col" : ""}`}
                        >
                          {this.lang("Alu")}
                        </th>
                        <th className="empty_row"></th>
                        <th
                          width={"5%"}
                          style={dynamic_Table_Colors}
                          className={`lak-tr both-top-border text-left ${this.props.viewType === "TabView" ? "green-col thead_bottom_border" : ""}`}
                        >
                          {this.lang("Lak")}
                        </th>



                        {/* <th className="replace-tr" width="5%">{this.lang("Replace")}</th> */}
                        {/* {this.props.is_extra_columns_visible &&<th className="replace-tr" width="30%">{this.lang("A + E")}</th>} */}
                        {this.props.is_extra_columns_visible && (
                          <>
                            <th className="empty_row"></th>
                            <th
                              width={"15%"}
                              style={dynamic_Table_Colors}
                              className={`replace-tr min-width-100 row-ae both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border dark-gray-col" : ""}`}
                            >
                              {this.lang("A + E")}
                            </th>
                            <th className="empty_row"></th>
                            {/* Ersetzen */}
                            <th
                              width={"15%"}
                              style={dynamic_Table_Colors}
                              className={`ersetzen-tr min-width-100 row-replace both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border green-col" : ""}`}
                            >
                              {this.lang('Replace')}
                            </th>
                          </>
                        )}
                        {this.props.is_extra_columns_visible &&
                          <>
                            <th className="empty_row"></th>
                            <th
                              width={"10%"}
                              style={dynamic_Table_Colors}
                              className={`replace-tr slike both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border" : ""}`}
                            >
                              {this.lang("Slike")}
                            </th>
                          </>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {Dents &&
                        Dents.map((row, index) => (
                          row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&

                          <tr className="" key={index}>
                            <td
                              style={dynamic_Table_Colors}
                              className="price-tbody-td ">
                              <p
                                onClick={() =>
                                  this.props.is_extra_columns_visible &&
                                  this.toggle(row.Part, true, row.Plastic)
                                }
                              >{this.lang(row.Part)}</p>
                              {/* {((Array.isArray(row.AE) && row.AE.length)  || (Array.isArray(row.Ersetzen) && row.Ersetzen.length)) ?
                              <p className="p-0 m-0">
                                {!this.props.is_extra_columns_visible && (
                                  <>
                                    {Array.isArray(row.AE) && row.AE.length
                                      ? "("
                                      : ""}
                                    {Array.isArray(row.AE) &&
                                      row.AE.map((data, index) => {
                                        return (
                                          <span>
                                            {this.lang(data)}
                                            {index == row.AE.length - 1 ? "" : ", "}
                                          </span>
                                        );
                                      })}
                                    {Array.isArray(row.AE) && row.AE.length
                                      ? ")"
                                      : ""}
                                  
                                    {Array.isArray(row.Ersetzen) &&
                                    row.Ersetzen.length
                                      ? "("
                                      : ""}
                                    {Array.isArray(row.Ersetzen) &&
                                      row.Ersetzen.map((data, index) => {
                                        return (
                                          <span>
                                            {this.lang(data)}
                                            {index == row.Ersetzen.length - 1
                                              ? ""
                                              : ", "}
                                          </span>
                                        );
                                      })}
                                    {Array.isArray(row.Ersetzen) &&
                                    row.Ersetzen.length
                                      ? ")"
                                      : ""}
                                  </>
                                )}
                              </p> : null} */}
                            </td>
                            <td className="empty_row"></td>

                            {
                              partnerId == "demo-sl" &&
                              <>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${this.props.viewType === "TabView" ? "dark-gray-col" : ""}`}
                                >
                                  {this.props.is_extra_columns_visible ?
                                    <>
                                      <input
                                        className="cross_input_table"
                                        type="checkbox"
                                        checked={row.Plastic}
                                        disabled={Authorized}
                                        onChange={(e) => {
                                          this.plasticChange(row.Part, e, index, "Plastic");
                                        }}
                                        id={index + "Plastic"}
                                      />
                                      <label
                                        className=""
                                        for={index + "Plastic"}
                                      />


                                    </>
                                    :
                                    row.Plastic ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                  }
                                </td>
                                <td className="empty_row"></td>
                              </>
                            }

                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td  text-center ${this.props.viewType === "TabView" ? "light-gray-col" : ""}`}
                            >
                              {this.props.is_extra_columns_visible ?
                                <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    name="A"
                                    type='number'
                                    disabled={Authorized}
                                    min='0'
                                    style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                    value={row.Plastic ? 0 : row.A}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.hadnleDentsChanges(row.part, e, index);
                                    }}
                                  />
                                  {!data.Authorized &&
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseInt(row.A) || 0) - 1, 0);
                                            this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index);
                                          }}
                                          disabled={data.Authorized || row.Plastic}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseInt(row.A) || 0) + 1;
                                            this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index);
                                          }}
                                          disabled={data.Authorized || row.Plastic}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </>
                                  }
                                </div>
                                :
                                (row.A).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                              }
                            </td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td  text-center ${this.props.viewType === "TabView" ? "light-gray-col" : ""}`}
                            >
                              {this.props.is_extra_columns_visible ?
                                <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    name="B"
                                    type='number'
                                    disabled={Authorized}
                                    min='0'
                                    style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                    value={row.Plastic ? 0 : row.B}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.hadnleDentsChanges(row.part, e, index);
                                    }}
                                  />
                                  {!data.Authorized &&
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseInt(row.B) || 0) - 1, 0);
                                            this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index);
                                          }}
                                          disabled={data.Authorized || row.Plastic}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseInt(row.B) || 0) + 1;
                                            this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index);
                                          }}
                                          disabled={data.Authorized || row.Plastic}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </>
                                  }
                                </div>
                                :
                                (row.B).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                              }
                              {/* {row.B} */}
                            </td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === "TabView" ? "light-gray-col" : ""}`}
                            >
                              {this.props.is_extra_columns_visible ?
                                <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    name="C"
                                    type='number'
                                    disabled={Authorized}
                                    min='0'
                                    style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                    value={row.Plastic ? 0 : row.C}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.hadnleDentsChanges(row.part, e, index);
                                    }}
                                  />
                                  {!data.Authorized &&
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseInt(row.C) || 0) - 1, 0);
                                            this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index);
                                          }}
                                          disabled={data.Authorized || row.Plastic}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseInt(row.C) || 0) + 1;
                                            this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index);
                                          }}
                                          disabled={data.Authorized || row.Plastic}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </>
                                  }
                                </div>
                                :
                                (row.C).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                              }
                              {/* {row.C} */}
                            </td>
                            <td className="empty_row"></td>

                            <td
                              className="price-tbody-td text-center"
                              style={dynamic_Table_Colors}
                            >
                              {(row.Plastic ? 0 : row.TotalDents).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}
                            </td>
                            <td className="empty_row"></td>

                            {/* <td className="" style={{ textAlign: "center" }}>
                              {" "}
                            </td> */}
                            {/* <td className="" style={{ textAlign: "center" }}>
                        <input
                          type="checkbox"
                          checked={row.Alu}
                          onChange={(e) => {
                            this.change(row.Part, e, index, "Alu");
                          }}
                        />
                      </td>
                      <td className="" style={{ textAlign: "center" }}>
                        <input
                          type="checkbox"
                          checked={row.Push2paint}
                          onChange={(e) => {
                            this.change(row.Part, e, index, "Push2paint");

                          }}
                        />
                      </td>
                      <td className="" style={{ textAlign: "center" }}>
                        <input
                          type="checkbox"
                          checked={row.Replace}
                          onChange={(e) => {
                            this.change(row.part, e, index, "Replace");
                          }}
                        />
                      </td> */}
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === "TabView" ? "orange-col" : ""}`}
                            >
                              {this.props.is_extra_columns_visible ?
                                <>
                                  <input
                                    className="cross_input_table"
                                    type="checkbox"
                                    disabled={Authorized}
                                    checked={row.Plastic ? false : row.Alu}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.change(row.Part, e, index, "Alu");
                                    }}
                                    id={index + "Alu"}
                                  />
                                  <label
                                    className=""
                                    for={index + "Alu"}
                                  />


                                </>
                                :
                                row.Alu ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                              }
                            </td>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === "TabView" ? "green-col" : ""}`}
                            >
                              {this.props.is_extra_columns_visible ?
                                <>
                                  <input
                                    className="cross_input_table"
                                    type="checkbox"
                                    disabled={Authorized}
                                    checked={row.Plastic ? false : row.Push2paint}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.change(row.Part, e, index, "Push2paint");
                                    }}
                                    id={index + "Push2paint"}
                                  />
                                  <label
                                    className=""
                                    for={index + "Push2paint"}
                                  />
                                </>
                                :
                                row.Push2paint ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                              }
                            </td>

                            {/* <td className="" style={{ textAlign: "center" }}>
                              {this.props.is_extra_columns_visible ?
                                <>
                                  <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    checked={row.Replace}
                                    onChange={(e) => {
                                      this.change(row.part, e, index, "Replace");
                                    }}
                                    id={index + "Replace"}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for={index + "Replace"}
                                  />
                                </>
                              :
                                row.Replace ? <span style={{fontSize:"16px"}}><i className="fa fa-check"></i></span> : ''
                              }
                            </td> */}
                            {this.props.is_extra_columns_visible && (
                              <>
                                <td className="empty_row"></td>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-left ${this.props.viewType === "TabView" ? "dark-gray-col" : ""}`}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {Array.isArray(row.arrAE) &&
                                        row.arrAE.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="w-100 d-flex">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      className="cross_input_table"
                                                      type="checkbox"
                                                      disabled={Authorized}
                                                      checked={
                                                        Array.isArray(
                                                          Dents[index]["AE"]
                                                        ) &&
                                                          Dents[index]["AE"].includes(
                                                            checkbox_val
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(event) =>
                                                        this.changeAE(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="">
                                                      {this.lang(checkbox_val)}
                                                    </p>
                                                  </div>

                                                </div>
                                                {/* <div className="row p-0">
                                                <div className="col-2 p-0">
                                                  <input
                                                    className="cross_input_table"
                                                    type="checkbox"
                                                    checked={
                                                      Array.isArray(
                                                        Dents[index]["AE"]
                                                      ) &&
                                                      Dents[index]["AE"].includes(
                                                        checkbox_val
                                                      )
                                                        ? true
                                                        : false
                                                    }
                                                    onClick={(event) =>
                                                      this.changeAE(
                                                        event,
                                                        index,
                                                        checkbox_val
                                                      )
                                                    }
                                                  />
                                                </div>
                                                <div className="col-10 p-0">
                                                  <p className="">
                                                    {this.lang(checkbox_val)}
                                                  </p>
                                                </div>
                                              </div> */}
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-left ${this.props.viewType === "TabView" ? "green-col" : ""}`}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {Array.isArray(row.arrErsetzen) &&
                                        row.arrErsetzen.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="w-100 d-flex text-left">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      type="checkbox"
                                                      disabled={Authorized}
                                                      className="cross_input_table"
                                                      checked={
                                                        Array.isArray(
                                                          Dents[index]["Ersetzen"]
                                                        ) &&
                                                          Dents[index][
                                                            "Ersetzen"
                                                          ].includes(checkbox_val)
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(event) => {
                                                        this.changeErsetzen(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                        )
                                                        // this.change(row.part, event, index, "Replace")
                                                      }
                                                      }
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                    {/* <img className="" style={{width:"15%"}} src={require(`../../views/Dashboard/icon/red-camera.svg`)} alt="" 
                                                    onClick={this.handlePartimages_extra}/> */}
                                                  </div>

                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </td><td className="empty_row"></td>
                              </>
                            )}
                            {this.props.is_extra_columns_visible && <td className="price-tbody-td" style={{ ...dynamic_Table_Colors, textAlign: "center" }} >
                              <input
                                type="file"
                                disabled={Authorized}
                                name="image"
                                id="file"
                                ref="Partimages"
                                accept="image/*"
                                capture="environment"
                                style={{ display: "none" }}
                                onChange={(e) => this.capture(e)}
                              />

                              {/* <img className="" src={require(`../../views/Dashboard/icon/black-camera.svg`)} style={{width:"35%"}} alt="" onClick={(e) =>this.handlePartimages_extra(e, row.Part , index)}/> */}
                              <div
                                className="col-12 column_image"
                                key={index}
                              >
                                <div
                                  className={`images-border-card ${this.imageExistOrNot_extra(row.Part, true) &&
                                    "coloroverlay"
                                    }`}
                                  style={{
                                    backgroundImage:
                                      this.imageExistOrNot_extra(row.Part, true)
                                        ? `url(${imageSrc})`
                                        : "",
                                  }}
                                  onClick={(e) => this.handlePartimages_extra(e, row.Part, index)}
                                >
                                  {(row.Part === captureImageName) && loading ?
                                    // {(name === captureImageName) ? 
                                    <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                      <span className="sr-only">Loading...</span>
                                    </div>
                                    :
                                    (
                                      <img
                                        className=""
                                        src={require(`../../views/Dashboard/icon/${this.imageExistOrNot_extra(
                                          row.Part
                                        )}-camera.svg`)}
                                        alt={row.Part}
                                      />
                                    )
                                  }
                                </div>
                              </div>
                            </td>}
                          </tr>
                        ))}
                      {/* <tr>
                      <td  style={{textAlign:"left", fontWeight:"normal"}}>{this.lang('Spare Parts cost')}</td>
                      <td colSpan={9}>      
                        {this.props.is_extra_columns_visible ?
                          <input 
                            type="text"
                            name="UserEnteredSparePartsDetails"
                            value={data.UserEnteredSparePartsDetails}
                            onChange={(e)=> this.handleChange(e)}
                            style={{width : '100%', border:'none', outline: 'none'}}
                          />
                        :
                        data.UserEnteredSparePartsDetails}
                      </td>
                    </tr> */}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr both-bottom-border text-left ${this.props.viewType === "TabView" ? "thead_top_border" : ""}`}
                        >
                          {this.lang("Total")}
                        </td>
                        <td className="empty_row"></td>
                        {
                          partnerId == "demo-sl" &&
                          <>
                            <td
                              style={dynamic_Table_Colors}
                              className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border dark-gray-col" : ""}`}
                            ></td>
                            <td className="empty_row"></td>

                          </>
                        }
                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr bottom-left-border text-center ${this.props.viewType === "TabView" ? "thead_top_border light-gray-col" : ""}`}
                        >
                          {Dents &&
                            Dents.reduce(
                              (acc, num) => {
                                if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                                  return parseInt(acc) + parseInt(num.Plastic ? 0 : num.A)
                                } else {
                                  return parseInt(acc)
                                }
                              },
                              0
                            )}
                        </td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr text-center ${this.props.viewType === "TabView" ? "thead_top_border light-gray-col" : ""}`}
                        >
                          {Dents &&
                            Dents.reduce(
                              (acc, num) => {
                                if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                                  return parseInt(acc) + parseInt(num.Plastic ? 0 : num.B)
                                } else {
                                  return parseInt(acc)
                                }
                              },
                              0
                            )}
                        </td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr bottom-right-border text-center ${this.props.viewType === "TabView" ? "thead_top_border light-gray-col" : ""}`}
                        >
                          {Dents &&
                            Dents.reduce(
                              (acc, num) => {
                                if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                                  return parseInt(acc) + parseInt(num.Plastic ? 0 : num.C)
                                } else {
                                  return parseInt(acc)
                                }
                              },
                              0
                            )}
                        </td>
                        <td className="empty_row"></td>

                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border" : ""}`}
                        >
                          {Dents &&
                            Dents.reduce(
                              (acc, num) =>
                                parseInt(acc) + parseInt(num.Plastic ? 0 : num.TotalDents),
                              0
                            )}
                        </td>
                        {/* <td
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          ></td> */}
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border orange-col" : ""}`}
                        ></td>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border green-col" : ""}`}
                        ></td>

                        {/* <td
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          ></td> */}
                        {/* {this.props.is_extra_columns_visible && <td
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          ></td>} */}

                        {this.props.is_extra_columns_visible && (
                          <>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "dark-gray-col thead_top_border" : ""}`}
                            ></td>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border green-col" : ""}`}
                            ></td>

                          </>
                        )}
                        {this.props.is_extra_columns_visible &&
                          <>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border" : ""}`}
                            ></td>
                          </>
                        }
                      </tr>
                      <tr>
                        <td className="empty_height"></td>
                      </tr>
                      {<tr className="notes_tr all_notes_tr">
                        <td
                          className="text-left footer-sl-td bottom-left-border"
                          style={dynamic_Table_Colors}
                        >
                          {this.lang("Notes")}
                        </td>
                        <td className="empty_row"></td>
                        <td
                          className="text-left footer-sl-td bottom-right-border"
                          style={dynamic_Table_Colors}
                          colSpan={18}
                        >
                          {this.props.is_extra_columns_visible ?
                            <input
                              name='UserNotesFooter'
                              disabled={Authorized}
                              type='text'
                              style={{ width: '100%', border: 'none', outline: 'none' }}
                              value={data.UserNotesFooter}
                              onChange={(e) => this.handleChange(e)}
                            />
                            :
                            data.UserNotesFooter
                            //  <>
                            //   <p className="updated-notes-text">

                            //   </p>
                            //  </>
                          }
                        </td>
                      </tr>}
                    </tfoot>
                  </table>
                </div>
                {/* Editor modal */}
                <Modal
                  size="xl"
                  isOpen={isEditor}
                  toggle={() => this.setState({ isEditor: !this.state.isEditor })}
                  className="modal1 image_editor_modal_main"
                >
                  <ModalBody>
                    <PhotoGalleryImageEditor
                      prepopulate={true}
                      staticImageUrl={this.state.imageUrl}
                      imageUrl={this.state.data64Url}
                      vin={vin}
                      imageName={this.state.imageName}
                      upload={() => this.upload()}
                    />
                  </ModalBody>
                </Modal>

                {/* Lightbox */}
                {this.state.isLightBoxOpen &&
                  <Lightbox
                    reactModalStyle={{
                      overlay: { zIndex: 100000000 },
                      content: {},
                    }}
                    toolbarButtons={toolbarButtons}
                    mainSrc={
                      `${configuration.imagePath}/scanImages/${partnerId}/${vin}/${this.state.extrapart[this.state.imageName]}`
                    }
                    onCloseRequest={() =>
                      this.setState({
                        isLightBoxOpen: false,
                      })
                    }
                    onImageLoadError={(...events) => console.log(events)}
                    imageLoadErrorMessage={<img style={{ height: '100%', width: "100%" }} src={require("../../assets/img/brand/dashboard-error-logo.png")} />}
                  />
                }
              </div>
            </div>}



          {/* check arr in A + E and Ersetzen column, show only mini and full report*/}
          {
            this.props.is_extra_columns_visible_mini_fullreport ?
              <div className="row report_tab_view_wrapper slovania-extra-page">
                <div className="col-lg-12 p-0">
                  <div className="table-responsive">
                    <table
                      width="100%"
                      className="table w-100"
                    // className=" table table-responsive-lg  w-100"
                    >
                      <thead>
                        <tr
                          width="100%"
                        >
                          <th
                            width="30%"
                            style={dynamic_Table_Colors}
                            className="both-top-border part-tr"
                          >
                            {this.lang("Damage Description")}
                          </th>
                          <th className="empty_row"></th>
                          <th
                            width="35%"
                            style={dynamic_Table_Colors}
                            className="both-top-border replace-tr row-ae"
                          >
                            {this.lang("A + E")}
                          </th>
                          <th className="empty_row"></th>
                          <th
                            width="35%"
                            style={dynamic_Table_Colors}
                            className="both-top-border ersetzen-tr row-replace"
                          >
                            {this.lang('Replace')}
                          </th>
                        </tr>
                      </thead>
                      <tbody width="100%">
                        {Dents &&
                          Dents.map((row, index) => {
                            return (
                              row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&
                              <tr className="" key={index}>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <p className="p-0 m-0">{this.lang(row.Part)}</p>
                                </td>
                                <td className="empty_row"></td>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      <div class="checkbox-grid-for-replace">
                                        {Array.isArray(row.arrAE) &&
                                          row.arrAE.map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="p-0 d-flex demo-flex-main">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        className="cross_input_table"
                                                        type="checkbox"
                                                        disabled={Authorized}
                                                        checked={
                                                          Array.isArray(
                                                            Dents[index]["AE"]
                                                          ) &&
                                                            Dents[index]["AE"].includes(
                                                              checkbox_val
                                                            )
                                                            ? true
                                                            : false
                                                        }
                                                      />

                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">
                                                        {this.lang(checkbox_val)}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      <div class="checkbox-grid-for-replace">
                                        {Array.isArray(row.arrErsetzen) &&
                                          row.arrErsetzen.map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="p-0 d-flex demo-flex-main">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        className="cross_input_table"
                                                        type="checkbox"
                                                        disabled={Authorized}
                                                        checked={
                                                          Array.isArray(
                                                            Dents[index]["Ersetzen"]
                                                          ) &&
                                                            Dents[index][
                                                              "Ersetzen"
                                                            ].includes(checkbox_val)
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                      <tfoot>
                        <tr
                          width="100%"
                        >
                          <th
                            width="30%"
                            style={dynamic_Table_Colors}
                            className="both-bottom-border part-tr"
                          >
                            {this.lang("Damage Description")}
                          </th>
                          <th className="empty_row"></th>
                          <th
                            width="35%"
                            style={dynamic_Table_Colors}
                            className="both-bottom-border replace-tr row-ae"
                          >
                            {this.lang("A + E")}
                          </th>
                          <th className="empty_row"></th>
                          <th
                            width="35%"
                            style={dynamic_Table_Colors}
                            className="both-bottom-border ersetzen-tr row-replace"
                          >
                            {this.lang('Replace')}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              :
              null
          }

          {modal && (
            <Lightbox
              reactModalStyle={{
                overlay: { zIndex: 100000000 },
                content: {},
              }}
              mainSrc={
                this.state.filteredImages.length > 0
                  ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                  : require("../../assets/img/brand/dashboard-error-logo.png")
              }
              imageCaption={this.state.filteredImages.length > 0 && this.lang(
                this.state.filteredImages[this.state.currentImageIndex]
                  .split('/')
                  .pop()
                  .replace(/^Report_/, '')
                  .replace(/_\d+\.jpg$/, '')
              )}
              nextSrc={
                `${this.state.filteredImages[
                (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                ]}?t=${new Date().getTime()}`
              }
              prevSrc={
                `${this.state.filteredImages[
                (this.state.currentImageIndex +
                  this.state.filteredImages.length -
                  1) % this.state.filteredImages.length
                ]}?t=${new Date().getTime()}`
              }
              onCloseRequest={() => this.setState({ modal: false })}
              onMovePrevRequest={() =>
                this.setState({
                  currentImageIndex:
                    (this.state.currentImageIndex +
                      this.state.filteredImages.length -
                      1) %
                    this.state.filteredImages.length,
                })
              }
              onMoveNextRequest={() =>
                this.setState({
                  currentImageIndex:
                    (this.state.currentImageIndex + 1) %
                    this.state.filteredImages.length,
                })
              }
              onImageLoadError={(...events) => console.log(events)}
              imageLoadErrorMessage={
                <img
                  style={{ height: "100%", width: "100%" }}
                  src={require("../../assets/img/brand/dashboard-error-logo.png")}
                />
              }
            />
          )}
        </div>
      </>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    toggleReportDamageImage: props.toggleReportDamageImage
  };
};
export default connect(mapStateToProps, mapDispatchtoProps)(SlovinaPriceTable);
